import { render, staticRenderFns } from "./NotificationCategoryOption.vue?vue&type=template&id=6f9d0dc0"
import script from "./NotificationCategoryOption.vue?vue&type=script&lang=ts"
export * from "./NotificationCategoryOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports